module.exports = __webpack_public_path__ + "static/media/icons8-gitlab.09845b96.svg";